import { render, staticRenderFns } from "./product-rating.vue?vue&type=template&id=347335be&scoped=true&"
import script from "./product-rating.vue?vue&type=script&lang=js&"
export * from "./product-rating.vue?vue&type=script&lang=js&"
import style0 from "./product-rating.vue?vue&type=style&index=0&id=347335be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347335be",
  null
  
)

export default component.exports